import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'presence.nameplate.more': {
    id: 'presence.nameplate.more',
    defaultMessage:
      '{numberOfAdditionalParticipants, plural, one {{numberOfAdditionalParticipants} more} other {{numberOfAdditionalParticipants} more}}',
    description:
      'When there are more participants than can be displayed, this string is used to indicate that there are additional participants.'
  }
});
